import * as CONSTANTS from '../constants/constants';

const initialState = {
  loading: false,
  tcContent: {},
  tcContentSuccess: ''
};

const contents = (state = initialState, action) => {
  // console.log(action)
  switch (action.type) {
    case CONSTANTS.GET_TC:
      return Object.assign({}, state, {
        loading: false,
        tcContent: action.tcContent
      });
    case CONSTANTS.UPDATE_TC:
      return Object.assign({}, state, {
        loading: true,
        tcContentSuccess: ''
      });
    case CONSTANTS.UPDATE_TC_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        tcContentSuccess: CONSTANTS.UPDATE_TC_SUCCESS_MSG
      });
    default:
      return state;
  }
};

export default contents;
